import "./main.css";
import {Item as $5ae296f2d6923e14$re_export$Item, Section as $5ae296f2d6923e14$re_export$Section} from "@react-stately/collections";
import {useDOMRef as $9SHwR$useDOMRef, useIsMobileDevice as $9SHwR$useIsMobileDevice, unwrapDOMRef as $9SHwR$unwrapDOMRef, classNames as $9SHwR$classNames, SlotProvider as $9SHwR$SlotProvider, useStyleProps as $9SHwR$useStyleProps, ClearSlots as $9SHwR$ClearSlots, useSlotProps as $9SHwR$useSlotProps} from "@react-spectrum/utils";
import {useOverlayPosition as $9SHwR$useOverlayPosition, DismissButton as $9SHwR$DismissButton} from "@react-aria/overlays";
import {FocusScope as $9SHwR$FocusScope, FocusRing as $9SHwR$FocusRing} from "@react-aria/focus";
import {Tray as $9SHwR$Tray, Popover as $9SHwR$Popover} from "@react-spectrum/overlays";
import {PressResponder as $9SHwR$PressResponder, useHover as $9SHwR$useHover} from "@react-aria/interactions";
import $9SHwR$react, {useRef as $9SHwR$useRef, Fragment as $9SHwR$Fragment, forwardRef as $9SHwR$forwardRef, useContext as $9SHwR$useContext} from "react";
import {useMenuTrigger as $9SHwR$useMenuTrigger, useMenu as $9SHwR$useMenu, useMenuItem as $9SHwR$useMenuItem, useMenuSection as $9SHwR$useMenuSection} from "@react-aria/menu";
import {useMenuTriggerState as $9SHwR$useMenuTriggerState} from "@react-stately/menu";
import {mergeProps as $9SHwR$mergeProps, useSyncRef as $9SHwR$useSyncRef, filterDOMProps as $9SHwR$filterDOMProps} from "@react-aria/utils";
import {useTreeState as $9SHwR$useTreeState} from "@react-stately/tree";
import $9SHwR$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import {Grid as $9SHwR$Grid} from "@react-spectrum/layout";
import {Text as $9SHwR$Text} from "@react-spectrum/text";
import {useSeparator as $9SHwR$useSeparator} from "@react-aria/separator";
import {ActionButton as $9SHwR$ActionButton} from "@react-spectrum/button";
import $9SHwR$spectrumiconsworkflowMore from "@spectrum-icons/workflow/More";
import {useLocalizedStringFormatter as $9SHwR$useLocalizedStringFormatter} from "@react-aria/i18n";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}




const $d94604d52c3e3feb$export$c7e742effb1c51e2 = $9SHwR$react.createContext({
});
function $d94604d52c3e3feb$export$21c7ab35b39f78ec() {
    return $9SHwR$useContext($d94604d52c3e3feb$export$c7e742effb1c51e2);
}





var $286d1cb34bb7dc84$exports = {};

$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-popover", () => $286d1cb34bb7dc84$export$d959f30786125b, (v) => $286d1cb34bb7dc84$export$d959f30786125b = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu", () => $286d1cb34bb7dc84$export$fae6af6decd50ac5, (v) => $286d1cb34bb7dc84$export$fae6af6decd50ac5 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-sectionHeading", () => $286d1cb34bb7dc84$export$c20ea4b35020fbdd, (v) => $286d1cb34bb7dc84$export$c20ea4b35020fbdd = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-checkmark", () => $286d1cb34bb7dc84$export$8e15a726e4f7e62d, (v) => $286d1cb34bb7dc84$export$8e15a726e4f7e62d = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-item", () => $286d1cb34bb7dc84$export$45faad328e6c532b, (v) => $286d1cb34bb7dc84$export$45faad328e6c532b = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selected", () => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a, (v) => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Icon", () => $286d1cb34bb7dc84$export$d374b04f30360026, (v) => $286d1cb34bb7dc84$export$d374b04f30360026 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel", () => $286d1cb34bb7dc84$export$1aa6419c5c650567, (v) => $286d1cb34bb7dc84$export$1aa6419c5c650567 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemIcon", () => $286d1cb34bb7dc84$export$f431001e1bb54633, (v) => $286d1cb34bb7dc84$export$f431001e1bb54633 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel--wrapping", () => $286d1cb34bb7dc84$export$465092164a8e1d98, (v) => $286d1cb34bb7dc84$export$465092164a8e1d98 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-divider", () => $286d1cb34bb7dc84$export$e892026f534efed8, (v) => $286d1cb34bb7dc84$export$e892026f534efed8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemGrid", () => $286d1cb34bb7dc84$export$ee5f52784f57f9c8, (v) => $286d1cb34bb7dc84$export$ee5f52784f57f9c8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selectable", () => $286d1cb34bb7dc84$export$fbd22ba224473193, (v) => $286d1cb34bb7dc84$export$fbd22ba224473193 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-end", () => $286d1cb34bb7dc84$export$926a1bb74ed65667, (v) => $286d1cb34bb7dc84$export$926a1bb74ed65667 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-icon", () => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a, (v) => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-description", () => $286d1cb34bb7dc84$export$36f1275051e39ead, (v) => $286d1cb34bb7dc84$export$36f1275051e39ead = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-keyboard", () => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f, (v) => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f = v);
$parcel$export($286d1cb34bb7dc84$exports, "focus-ring", () => $286d1cb34bb7dc84$export$f39a09f249340e2a, (v) => $286d1cb34bb7dc84$export$f39a09f249340e2a = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-focused", () => $286d1cb34bb7dc84$export$e7dc768d35940237, (v) => $286d1cb34bb7dc84$export$e7dc768d35940237 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-hovered", () => $286d1cb34bb7dc84$export$b8813cd5d7824ce7, (v) => $286d1cb34bb7dc84$export$b8813cd5d7824ce7 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-highlighted", () => $286d1cb34bb7dc84$export$451c613d0772eb99, (v) => $286d1cb34bb7dc84$export$451c613d0772eb99 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-open", () => $286d1cb34bb7dc84$export$a9781837241c946d, (v) => $286d1cb34bb7dc84$export$a9781837241c946d = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-active", () => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f, (v) => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-disabled", () => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf, (v) => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf = v);
var $286d1cb34bb7dc84$export$d959f30786125b;
var $286d1cb34bb7dc84$export$fae6af6decd50ac5;
var $286d1cb34bb7dc84$export$c20ea4b35020fbdd;
var $286d1cb34bb7dc84$export$8e15a726e4f7e62d;
var $286d1cb34bb7dc84$export$45faad328e6c532b;
var $286d1cb34bb7dc84$export$1e0fb04f31d3c22a;
var $286d1cb34bb7dc84$export$d374b04f30360026;
var $286d1cb34bb7dc84$export$1aa6419c5c650567;
var $286d1cb34bb7dc84$export$f431001e1bb54633;
var $286d1cb34bb7dc84$export$465092164a8e1d98;
var $286d1cb34bb7dc84$export$e892026f534efed8;
var $286d1cb34bb7dc84$export$ee5f52784f57f9c8;
var $286d1cb34bb7dc84$export$fbd22ba224473193;
var $286d1cb34bb7dc84$export$926a1bb74ed65667;
var $286d1cb34bb7dc84$export$cbbae63ef9e44c7a;
var $286d1cb34bb7dc84$export$36f1275051e39ead;
var $286d1cb34bb7dc84$export$4f9817a7dff6ba0f;
var $286d1cb34bb7dc84$export$f39a09f249340e2a;
var $286d1cb34bb7dc84$export$e7dc768d35940237;
var $286d1cb34bb7dc84$export$b8813cd5d7824ce7;
var $286d1cb34bb7dc84$export$451c613d0772eb99;
var $286d1cb34bb7dc84$export$a9781837241c946d;
var $286d1cb34bb7dc84$export$20fd0f7cd4e6112f;
var $286d1cb34bb7dc84$export$d35bc1e505d1ebbf;
$286d1cb34bb7dc84$export$d959f30786125b = "spectrum-Menu-popover_7ea47c";
$286d1cb34bb7dc84$export$fae6af6decd50ac5 = "spectrum-Menu_7ea47c";
$286d1cb34bb7dc84$export$c20ea4b35020fbdd = "spectrum-Menu-sectionHeading_7ea47c";
$286d1cb34bb7dc84$export$8e15a726e4f7e62d = "spectrum-Menu-checkmark_7ea47c";
$286d1cb34bb7dc84$export$45faad328e6c532b = "spectrum-Menu-item_7ea47c";
$286d1cb34bb7dc84$export$1e0fb04f31d3c22a = "is-selected_7ea47c";
$286d1cb34bb7dc84$export$d374b04f30360026 = "spectrum-Icon_7ea47c";
$286d1cb34bb7dc84$export$1aa6419c5c650567 = "spectrum-Menu-itemLabel_7ea47c";
$286d1cb34bb7dc84$export$f431001e1bb54633 = "spectrum-Menu-itemIcon_7ea47c";
$286d1cb34bb7dc84$export$465092164a8e1d98 = "spectrum-Menu-itemLabel--wrapping_7ea47c";
$286d1cb34bb7dc84$export$e892026f534efed8 = "spectrum-Menu-divider_7ea47c";
$286d1cb34bb7dc84$export$ee5f52784f57f9c8 = "spectrum-Menu-itemGrid_7ea47c";
$286d1cb34bb7dc84$export$fbd22ba224473193 = "is-selectable_7ea47c";
$286d1cb34bb7dc84$export$926a1bb74ed65667 = "spectrum-Menu-end_7ea47c";
$286d1cb34bb7dc84$export$cbbae63ef9e44c7a = "spectrum-Menu-icon_7ea47c";
$286d1cb34bb7dc84$export$36f1275051e39ead = "spectrum-Menu-description_7ea47c";
$286d1cb34bb7dc84$export$4f9817a7dff6ba0f = "spectrum-Menu-keyboard_7ea47c";
$286d1cb34bb7dc84$export$f39a09f249340e2a = "focus-ring_7ea47c";
$286d1cb34bb7dc84$export$e7dc768d35940237 = "is-focused_7ea47c";
$286d1cb34bb7dc84$export$b8813cd5d7824ce7 = "is-hovered_7ea47c";
$286d1cb34bb7dc84$export$451c613d0772eb99 = "is-highlighted_7ea47c";
$286d1cb34bb7dc84$export$a9781837241c946d = "is-open_7ea47c";
$286d1cb34bb7dc84$export$20fd0f7cd4e6112f = "is-active_7ea47c";
$286d1cb34bb7dc84$export$d35bc1e505d1ebbf = "is-disabled_7ea47c";




function $aa0b855f135b86e3$var$MenuTrigger(props, ref) {
    let menuPopoverRef = $9SHwR$useRef();
    let triggerRef = $9SHwR$useRef();
    let domRef = $9SHwR$useDOMRef(ref);
    let menuTriggerRef = domRef || triggerRef;
    let menuRef = $9SHwR$useRef();
    let { children: children , align: align = 'start' , shouldFlip: shouldFlip = true , direction: direction = 'bottom' , closeOnSelect: closeOnSelect , trigger: trigger = 'press'  } = props;
    let [menuTrigger, menu] = $9SHwR$react.Children.toArray(children);
    let state = $9SHwR$useMenuTriggerState(props);
    let { menuTriggerProps: menuTriggerProps , menuProps: menuProps  } = $9SHwR$useMenuTrigger({
        trigger: trigger
    }, state, menuTriggerRef);
    let initialPlacement;
    switch(direction){
        case 'left':
        case 'right':
        case 'start':
        case 'end':
            initialPlacement = `${direction} ${align === 'end' ? 'bottom' : 'top'}`;
            break;
        case 'bottom':
        case 'top':
        default:
            initialPlacement = `${direction} ${align}`;
    }
    let isMobile = $9SHwR$useIsMobileDevice();
    let { overlayProps: positionProps , placement: placement  } = $9SHwR$useOverlayPosition({
        targetRef: menuTriggerRef,
        overlayRef: $9SHwR$unwrapDOMRef(menuPopoverRef),
        scrollRef: menuRef,
        placement: initialPlacement,
        shouldFlip: shouldFlip,
        isOpen: state.isOpen && !isMobile,
        onClose: state.close
    });
    let menuContext = {
        ...menuProps,
        ref: menuRef,
        onClose: state.close,
        closeOnSelect: closeOnSelect,
        autoFocus: state.focusStrategy || true,
        UNSAFE_style: isMobile ? {
            width: '100%',
            maxHeight: 'inherit'
        } : undefined,
        UNSAFE_className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), {
            'spectrum-Menu-popover': !isMobile
        })
    };
    // Only contain focus while the menu is open. There is a fade out transition during which we may try to move focus.
    // If we contain, then focus will be pulled back into the menu.
    let contents = /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$FocusScope, {
        restoreFocus: true,
        contain: isMobile && state.isOpen
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$DismissButton, {
        onDismiss: state.close
    }), menu, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$DismissButton, {
        onDismiss: state.close
    }));
    // On small screen devices, the menu is rendered in a tray, otherwise a popover.
    let overlay;
    if (isMobile) overlay = /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Tray, {
        isOpen: state.isOpen,
        onClose: state.close
    }, contents);
    else overlay = /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Popover, {
        isOpen: state.isOpen,
        UNSAFE_style: positionProps.style,
        ref: menuPopoverRef,
        placement: placement,
        hideArrow: true,
        onClose: state.close,
        shouldCloseOnBlur: true
    }, contents);
    return(/*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Fragment, null, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$SlotProvider, {
        slots: {
            actionButton: {
                holdAffordance: trigger === 'longPress'
            }
        }
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$PressResponder, {
        ...menuTriggerProps,
        ref: menuTriggerRef,
        isPressed: state.isOpen
    }, menuTrigger)), /*#__PURE__*/ $9SHwR$react.createElement($d94604d52c3e3feb$export$c7e742effb1c51e2.Provider, {
        value: menuContext
    }, overlay)));
}
/**
 * The MenuTrigger serves as a wrapper around a Menu and its associated trigger,
 * linking the Menu's open state with the trigger's press state.
 */ let $aa0b855f135b86e3$export$27d2ad3c5815583e = /*#__PURE__*/ $9SHwR$forwardRef($aa0b855f135b86e3$var$MenuTrigger);















function $48fb8f5e1202c980$export$2ce376c2cc3355c8(props) {
    let { item: item , state: state , isVirtualized: isVirtualized , onAction: onAction  } = props;
    let { onClose: onClose , closeOnSelect: closeOnSelect  } = $d94604d52c3e3feb$export$21c7ab35b39f78ec();
    let { rendered: rendered , key: key  } = item;
    let isSelected = state.selectionManager.isSelected(key);
    let isDisabled = state.disabledKeys.has(key);
    let ref = $9SHwR$useRef();
    let { menuItemProps: menuItemProps , labelProps: labelProps , descriptionProps: descriptionProps , keyboardShortcutProps: keyboardShortcutProps  } = $9SHwR$useMenuItem({
        isSelected: isSelected,
        isDisabled: isDisabled,
        'aria-label': item['aria-label'],
        key: key,
        onClose: onClose,
        closeOnSelect: closeOnSelect,
        isVirtualized: isVirtualized,
        onAction: onAction
    }, state, ref);
    let { hoverProps: hoverProps , isHovered: isHovered  } = $9SHwR$useHover({
        isDisabled: isDisabled
    });
    let contents = typeof rendered === 'string' ? /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Text, null, rendered) : rendered;
    return(/*#__PURE__*/ $9SHwR$react.createElement($9SHwR$FocusRing, {
        focusRingClass: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'focus-ring')
    }, /*#__PURE__*/ $9SHwR$react.createElement("li", {
        ...$9SHwR$mergeProps(menuItemProps, hoverProps),
        ref: ref,
        className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu-item', {
            'is-disabled': isDisabled,
            'is-selected': isSelected,
            'is-selectable': state.selectionManager.selectionMode !== 'none',
            'is-hovered': isHovered
        })
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Grid, {
        UNSAFE_className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu-itemGrid')
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$ClearSlots, null, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$SlotProvider, {
        slots: {
            text: {
                UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))['spectrum-Menu-itemLabel'],
                ...labelProps
            },
            end: {
                UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))['spectrum-Menu-end'],
                ...descriptionProps
            },
            icon: {
                UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))['spectrum-Menu-icon'],
                size: 'S'
            },
            description: {
                UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))['spectrum-Menu-description'],
                ...descriptionProps
            },
            keyboard: {
                UNSAFE_className: (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))['spectrum-Menu-keyboard'],
                ...keyboardShortcutProps
            }
        }
    }, contents, isSelected && /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$spectrumiconsuiCheckmarkMedium, {
        slot: "checkmark",
        UNSAFE_className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu-checkmark')
    })))))));
}








function $b966e606890cc5ca$export$4b1545b4f2016d26(props) {
    let { item: item1 , state: state , onAction: onAction  } = props;
    let { itemProps: itemProps , headingProps: headingProps , groupProps: groupProps  } = $9SHwR$useMenuSection({
        heading: item1.rendered,
        'aria-label': item1['aria-label']
    });
    let { separatorProps: separatorProps  } = $9SHwR$useSeparator({
        elementType: 'li'
    });
    return(/*#__PURE__*/ $9SHwR$react.createElement($9SHwR$Fragment, null, item1.key !== state.collection.getFirstKey() && /*#__PURE__*/ $9SHwR$react.createElement("li", {
        ...separatorProps,
        className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu-divider')
    }), /*#__PURE__*/ $9SHwR$react.createElement("li", itemProps, item1.rendered && /*#__PURE__*/ $9SHwR$react.createElement("span", {
        ...headingProps,
        className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu-sectionHeading')
    }, item1.rendered), /*#__PURE__*/ $9SHwR$react.createElement("ul", {
        ...groupProps,
        className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu')
    }, [
        ...item1.childNodes
    ].map((node)=>{
        let item = /*#__PURE__*/ $9SHwR$react.createElement($48fb8f5e1202c980$export$2ce376c2cc3355c8, {
            key: node.key,
            item: node,
            state: state,
            onAction: onAction
        });
        if (node.wrapper) item = node.wrapper(item);
        return item;
    })))));
}







function $49b26f4b606348f6$var$Menu(props, ref) {
    let contextProps = $9SHwR$useContext($d94604d52c3e3feb$export$c7e742effb1c51e2);
    let completeProps = {
        ...$9SHwR$mergeProps(contextProps, props)
    };
    let domRef = $9SHwR$useDOMRef(ref);
    let state = $9SHwR$useTreeState(completeProps);
    let { menuProps: menuProps  } = $9SHwR$useMenu(completeProps, state, domRef);
    let { styleProps: styleProps  } = $9SHwR$useStyleProps(completeProps);
    $9SHwR$useSyncRef(contextProps, domRef);
    return(/*#__PURE__*/ $9SHwR$react.createElement("ul", {
        ...menuProps,
        ...styleProps,
        ref: domRef,
        className: $9SHwR$classNames((/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)), 'spectrum-Menu', styleProps.className)
    }, [
        ...state.collection
    ].map((item)=>{
        if (item.type === 'section') return(/*#__PURE__*/ $9SHwR$react.createElement($b966e606890cc5ca$export$4b1545b4f2016d26, {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        }));
        let menuItem = /*#__PURE__*/ $9SHwR$react.createElement($48fb8f5e1202c980$export$2ce376c2cc3355c8, {
            key: item.key,
            item: item,
            state: state,
            onAction: completeProps.onAction
        });
        if (item.wrapper) menuItem = item.wrapper(menuItem);
        return menuItem;
    })));
}
/**
 * Menus display a list of actions or options that a user can choose.
 */ // forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const $49b26f4b606348f6$export$d9b273488cd8ce6f = /*#__PURE__*/ $9SHwR$react.forwardRef($49b26f4b606348f6$var$Menu);




var $d01b612f05eb8a1a$exports = {};
var $9c47fa309a7d4d43$exports = {};
$9c47fa309a7d4d43$exports = {
    "moreActions": `المزيد من الإجراءات`
};


var $4cd8d8b72a119260$exports = {};
$4cd8d8b72a119260$exports = {
    "moreActions": `Повече действия`
};


var $10556a59bf2ddefc$exports = {};
$10556a59bf2ddefc$exports = {
    "moreActions": `Další akce`
};


var $c31b6134a3770ee4$exports = {};
$c31b6134a3770ee4$exports = {
    "moreActions": `Flere handlinger`
};


var $16c606e9b72a71c3$exports = {};
$16c606e9b72a71c3$exports = {
    "moreActions": `Mehr Aktionen`
};


var $055104befa589c0a$exports = {};
$055104befa589c0a$exports = {
    "moreActions": `Περισσότερες ενέργειες`
};


var $de5da9cdd5bee12a$exports = {};
$de5da9cdd5bee12a$exports = {
    "moreActions": `More actions`
};


var $db3723c51a085311$exports = {};
$db3723c51a085311$exports = {
    "moreActions": `Más acciones`
};


var $5cd99c404e06eb9f$exports = {};
$5cd99c404e06eb9f$exports = {
    "moreActions": `Veel toiminguid`
};


var $65f73c6fde514402$exports = {};
$65f73c6fde514402$exports = {
    "moreActions": `Lisää toimintoja`
};


var $0f0e6467596070ec$exports = {};
$0f0e6467596070ec$exports = {
    "moreActions": `Autres actions`
};


var $93c080405bcb117f$exports = {};
$93c080405bcb117f$exports = {
    "moreActions": `פעולות נוספות`
};


var $4c9dcf87f189563f$exports = {};
$4c9dcf87f189563f$exports = {
    "moreActions": `Dodatne radnje`
};


var $9be03138870991df$exports = {};
$9be03138870991df$exports = {
    "moreActions": `További lehetőségek`
};


var $ad8c9cad3dbd650f$exports = {};
$ad8c9cad3dbd650f$exports = {
    "moreActions": `Altre azioni`
};


var $bc78ecf2de5c1277$exports = {};
$bc78ecf2de5c1277$exports = {
    "moreActions": `その他のアクション`
};


var $e1819c2136902bf7$exports = {};
$e1819c2136902bf7$exports = {
    "moreActions": `기타 작업`
};


var $99b345867a868892$exports = {};
$99b345867a868892$exports = {
    "moreActions": `Daugiau veiksmų`
};


var $5f3754867e416768$exports = {};
$5f3754867e416768$exports = {
    "moreActions": `Citas darbības`
};


var $68ce88a369285902$exports = {};
$68ce88a369285902$exports = {
    "moreActions": `Flere handlinger`
};


var $e9243a5fd645a2cf$exports = {};
$e9243a5fd645a2cf$exports = {
    "moreActions": `Meer handelingen`
};


var $ab29dff56735387a$exports = {};
$ab29dff56735387a$exports = {
    "moreActions": `Więcej akcji`
};


var $d943521233798059$exports = {};
$d943521233798059$exports = {
    "moreActions": `Mais ações`
};


var $3ad4dfd69f313220$exports = {};
$3ad4dfd69f313220$exports = {
    "moreActions": `Mais ações`
};


var $22fbf25776bcbdd5$exports = {};
$22fbf25776bcbdd5$exports = {
    "moreActions": `Mai multe acțiuni`
};


var $ae7dddfad0448b8a$exports = {};
$ae7dddfad0448b8a$exports = {
    "moreActions": `Дополнительные действия`
};


var $3a572e5fc81706d7$exports = {};
$3a572e5fc81706d7$exports = {
    "moreActions": `Ďalšie akcie`
};


var $f510599a6178d1bd$exports = {};
$f510599a6178d1bd$exports = {
    "moreActions": `Več možnosti`
};


var $931fd402ea71f56a$exports = {};
$931fd402ea71f56a$exports = {
    "moreActions": `Dodatne radnje`
};


var $afa6d5819988437d$exports = {};
$afa6d5819988437d$exports = {
    "moreActions": `Fler åtgärder`
};


var $6ef9c252e9fbc070$exports = {};
$6ef9c252e9fbc070$exports = {
    "moreActions": `Daha fazla eylem`
};


var $9a5e4d563d152847$exports = {};
$9a5e4d563d152847$exports = {
    "moreActions": `Більше дій`
};


var $57bb191f18e8be40$exports = {};
$57bb191f18e8be40$exports = {
    "moreActions": `更多操作`
};


var $56f3d9ca2967952d$exports = {};
$56f3d9ca2967952d$exports = {
    "moreActions": `更多動作`
};


$d01b612f05eb8a1a$exports = {
    "ar-AE": $9c47fa309a7d4d43$exports,
    "bg-BG": $4cd8d8b72a119260$exports,
    "cs-CZ": $10556a59bf2ddefc$exports,
    "da-DK": $c31b6134a3770ee4$exports,
    "de-DE": $16c606e9b72a71c3$exports,
    "el-GR": $055104befa589c0a$exports,
    "en-US": $de5da9cdd5bee12a$exports,
    "es-ES": $db3723c51a085311$exports,
    "et-EE": $5cd99c404e06eb9f$exports,
    "fi-FI": $65f73c6fde514402$exports,
    "fr-FR": $0f0e6467596070ec$exports,
    "he-IL": $93c080405bcb117f$exports,
    "hr-HR": $4c9dcf87f189563f$exports,
    "hu-HU": $9be03138870991df$exports,
    "it-IT": $ad8c9cad3dbd650f$exports,
    "ja-JP": $bc78ecf2de5c1277$exports,
    "ko-KR": $e1819c2136902bf7$exports,
    "lt-LT": $99b345867a868892$exports,
    "lv-LV": $5f3754867e416768$exports,
    "nb-NO": $68ce88a369285902$exports,
    "nl-NL": $e9243a5fd645a2cf$exports,
    "pl-PL": $ab29dff56735387a$exports,
    "pt-BR": $d943521233798059$exports,
    "pt-PT": $3ad4dfd69f313220$exports,
    "ro-RO": $22fbf25776bcbdd5$exports,
    "ru-RU": $ae7dddfad0448b8a$exports,
    "sk-SK": $3a572e5fc81706d7$exports,
    "sl-SI": $f510599a6178d1bd$exports,
    "sr-SP": $931fd402ea71f56a$exports,
    "sv-SE": $afa6d5819988437d$exports,
    "tr-TR": $6ef9c252e9fbc070$exports,
    "uk-UA": $9a5e4d563d152847$exports,
    "zh-CN": $57bb191f18e8be40$exports,
    "zh-TW": $56f3d9ca2967952d$exports
};








function $43fa9949e6af393d$var$ActionMenu(props, ref) {
    props = $9SHwR$useSlotProps(props, 'actionMenu');
    let stringFormatter = $9SHwR$useLocalizedStringFormatter((/*@__PURE__*/$parcel$interopDefault($d01b612f05eb8a1a$exports)));
    let buttonProps = $9SHwR$filterDOMProps(props, {
        labelable: true
    });
    if (buttonProps['aria-label'] === undefined) buttonProps['aria-label'] = stringFormatter.format('moreActions');
    return(/*#__PURE__*/ $9SHwR$react.createElement($aa0b855f135b86e3$export$27d2ad3c5815583e, {
        isOpen: props.isOpen,
        defaultOpen: props.defaultOpen,
        onOpenChange: props.onOpenChange,
        align: props.align,
        direction: props.direction,
        shouldFlip: props.shouldFlip
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$ActionButton, {
        ref: ref,
        ...props,
        ...buttonProps
    }, /*#__PURE__*/ $9SHwR$react.createElement($9SHwR$spectrumiconsworkflowMore, null)), /*#__PURE__*/ $9SHwR$react.createElement($49b26f4b606348f6$export$d9b273488cd8ce6f, {
        children: props.children,
        items: props.items,
        disabledKeys: props.disabledKeys,
        onAction: props.onAction
    })));
}
/**
 * ActionMenu combines an ActionButton with a Menu for simple "more actions" use cases.
 */ const $43fa9949e6af393d$export$ed57a210b9d13bb6 = /*#__PURE__*/ $9SHwR$forwardRef($43fa9949e6af393d$var$ActionMenu);





export {$aa0b855f135b86e3$export$27d2ad3c5815583e as MenuTrigger, $49b26f4b606348f6$export$d9b273488cd8ce6f as Menu, $43fa9949e6af393d$export$ed57a210b9d13bb6 as ActionMenu, $5ae296f2d6923e14$re_export$Item as Item, $5ae296f2d6923e14$re_export$Section as Section};
//# sourceMappingURL=module.js.map
